import React, { useState, useEffect, Fragment } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Button, Spinner, Col, Row, Form, FormGroup, Label, Input, Alert,
    Nav, NavItem, NavLink, TabContent, TabPane, CustomInput,
    Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, FormText, Container, ListGroup, ListGroupItem, ListGroupItemHeading, Progress } from 'reactstrap';
import { Prompt, NavLink as RouterNavLink, Link } from 'react-router-dom';
// @ts-ignore
import Select from 'react-select';
// @ts-ignore
import randomstring from "randomstring";
import BlobUtil from '../../utils/blobUtil';

export default function DetailForm({props, read, save, remove, 
    overwriteWarningFlag, overwriteHandleWarning, isNew, positionList}: any) {
  
  const [overwriteFlag, setOverwriteFlag] = useState("false");
  const [removeWarning, setRemoveWarning] = useState(false);
  const toggleRemoveWarning = () => setRemoveWarning(!removeWarning);

  const [eTag, setETag] = useState(""); // Detect changes on data
  const [isSaved, setIsSaved] = useState(false);
  
  const [ _inputFile, setInputFile ] = useState();
  const [ _logoImge, setLogoImage ] = useState(props.data?.orgProfileImgURL);
  const [ _logoImageFlag, setLogoImageFlag] = useState(true);
  const [ _uploadProgress, setUploadProgress ] = useState(0);
  const [ UploadFlag, setUploadFlag] = useState(false);
  const toggleUploadFlag = () => {
    setUploadFlag(!UploadFlag);
  }

  const { register, handleSubmit, reset, watch, errors, formState, control  } = useForm();
  
  // Read the formState before render to subscribe the form state through Proxy
  const { dirty, isSubmitting, isSubmitted, touched, submitCount } = formState;
  
  const onSubmit = (data : any, e: any) => {
    //console.log(data)
    save(data);
    setIsSaved(true);
  };

  const watchFields = watch(["_etag"]);
  if (watchFields){
      if (watchFields._etag !== undefined && props.data?._etag !== undefined && (eTag === "" || eTag != props.data?._etag)){
        setETag(props.data._etag);
        //console.log("_etag updated..." + props.data._etag);
        if (isSaved){ // Reset only if record updated and issubmitted
            //console.log("Call Reset");
            setTimeout(() => {
                reset();
                setIsSaved(false);
            }, 0)
            
        }
      }
  }

  const handleRequestDelete = () => {
    remove(props.data);
    setRemoveWarning(!removeWarning);
  }
  
  const handleReloadData = () => {
    read();
    overwriteHandleWarning();
  }
  
  const _professionalCategory = [
    { value: 'Accountancy', label: 'Accountancy' },
    { value: 'Company Secretary', label: 'Company Secretary' },
    { value: 'Tax Agent', label: 'Tax Agent' },
    { value: 'Contractor', label: 'Contractor' },
    { value: 'Engineering', label: 'Engineering' },
  ];
  
  const handleMultiSelectedOption = (optionList: any, name: any) => {
    let arr: any = [];
    if (name){
        name.forEach((element:any) => {
            let index = optionList.map(function(e: any) { 
                return e.label; 
            }).indexOf(element);
    
            if (index !== -1) {
                arr.push(optionList[index]);
            }
            else {
                optionList.push({value: element, label: element});
                let index1 = optionList.map(function(e: any) { 
                    return e.label; 
                }).indexOf(element);
                arr.push(optionList[index1]);
            }
        });
    }

    return arr;
  }

  const handleOrgLogo = (event: any) => {
    event.preventDefault();
    
    if (event.target.files.length > 0) {
        let randomString = randomstring.generate({
            length: 6,
            charset: 'alphanumeric',
            capitalization: 'uppercase'
        });
        let filename = "general/" + randomString + ".jpg";
        setLogoImage(filename);
        setLogoImageFlag(!_logoImageFlag);
        setInputFile(event.target.files);
    }
  }
  
  async function handleUploadAction(event: any) {
    event.preventDefault();

    let fileName = '';
    let target = event.target.name;
    let fileUploadProgressInterval: any;
    let blobUtil = new BlobUtil();

    setUploadProgress(0);

    if (target === "image") fileName = _logoImge;

    if (_inputFile) {
        setUploadFlag(false);
        toggleUploadFlag();
        fileUploadProgressInterval = setInterval(async () => {
            setUploadProgress(blobUtil.getUploadProgress());
        }, 500);

        let blobRequestUrl = await blobUtil.UploadBlobToCointainer3(fileName, _inputFile[0], "images");  
        clearInterval(fileUploadProgressInterval);
        setUploadProgress(100);

        if (target === "image") setLogoImageFlag(!_logoImageFlag);
    }    
    else {
        alert("Please select file first before upload.");
        return ;
    }
  }
  
  return (
      <Fragment>
        <Form id='DetailsFrom' className="mt-12 mb-12" onSubmit={handleSubmit(onSubmit)}>
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Organization Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="orgName" sm={3}>Name</Label >
                            <Col lg={6} sm={6}>
                                <Input type="text" name="orgName" defaultValue={props.data?.orgName}
                                    innerRef={register({ required: true, minLength:10 })} />
                                {errors.orgName && <FormText color="danger">Required field. Minimum length 10 character.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="orgProfile" sm={3}>Profile</Label >
                            <Col lg={6} sm={10}>
                                <Input type="textarea" name="orgProfile" id="orgProfile"
                                    defaultValue={props.data?.orgProfile} rows={3} style={{width: "100%"}}
                                    innerRef={register}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="orgEmail" lg={3} sm={2}>Email</Label >
                            <Col lg={6} sm={10}>
                                <Input type="email" name="orgEmail" 
                                    defaultValue={props.data?.orgEmail} 
                                    innerRef={register} />

                                {errors.orgEmail && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="orgPhoneNo" lg={3} sm={2}>Phone Number</Label >
                            <Col lg={6} sm={10}>
                                <Input type="text" name="orgPhoneNo" 
                                    defaultValue={props.data?.orgPhoneNo} 
                                    innerRef={register} />

                                {errors.orgPhoneNo && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="orgAddress" sm={3}>Address</Label >
                            <Col lg={6} sm={10}>
                                <Input type="textarea" name="orgAddress" id="orgAddress"
                                    defaultValue={props.data?.orgAddress} rows={3} style={{width: "100%"}}
                                    innerRef={register}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="orgProfession" lg={3} sm={2}>Professional</Label >
                            <Col lg={9} sm={10}>
                                <Controller 
                                    as={Select}
                                    name="orgProfession"
                                    classNamePrefix="custom-select"
                                    options={_professionalCategory}
                                    isMulti
                                    control={control}
                                    defaultValue={handleMultiSelectedOption(_professionalCategory, props.data?.orgProfession)}
                                />
                                {errors.orgProfession && <FormText color="danger">Required field.</FormText>}
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="img" lg={3} sm={2}>Upload Logo&nbsp;<span style={{fontSize:"smaller"}}>(1280px x 800px)</span></Label >
                            <Col lg={7} sm={4} style={{display: "flex"}}>
                                <CustomInput type="file" name="img" accept="image/png, image/jpeg, image/jpg" 
                                    onChange={handleOrgLogo} 
                                    innerRef={register} />
                            </Col>
                            <Button color="primary" disabled={_logoImageFlag} name="image" onClick={handleUploadAction}>Upload</Button>
                            {
                                _logoImageFlag === true && _logoImge && (
                                    <Col lg={12} sm={12} style={{paddingTop: "10px", textAlign: "center"}}>
                                        <img 
                                            src={"https://images.ultimatespro.com/images/" + _logoImge.replace(".jpg","_md.jpg") } 
                                            hidden={(_logoImge) ? false : true} 
                                            alt="" 
                                            width={200} 
                                        />
                                    </Col>
                                )
                            }
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />
            <ListGroup>
                <ListGroupItem>
                    <ListGroupItemHeading>Contact Person Information</ListGroupItemHeading>
                    <ListGroupItem>
                        <FormGroup row={true}>
                            <Label for="contactPersonTitle" sm={3}>Title</Label >
                            <Col lg={6} sm={9}>
                                <Input type="text" name="contactPersonTitle"
                                    defaultValue={props.data?.contactPersonTitle}
                                    innerRef={register({ required: true })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactPersonName" sm={3}>Name</Label >
                            <Col lg={6} sm={9}>
                                <Input type="text" name="contactPersonName"
                                    defaultValue={props.data?.contactPersonName}
                                    innerRef={register({ required: true })}
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactPersonPhone" lg={3} sm={2}>Phone Number</Label >
                            <Col lg={6} sm={10}>
                                <Input type="text" name="contactPersonPhone" 
                                    defaultValue={props.data?.contactPersonPhone} 
                                    innerRef={register({ required: true })} />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactPersonWorkPhone" lg={3} sm={2}>Work  Phone Number</Label >
                            <Col lg={6} sm={10}>
                                <Input type="text" name="contactPersonWorkPhone" 
                                    defaultValue={props.data?.contactPersonWorkPhone} 
                                    innerRef={register({ required: true })} />
                            </Col>
                        </FormGroup>
                        <FormGroup row={true}>
                            <Label for="contactPersonEmail" lg={3} sm={2}>Email</Label >
                            <Col lg={6} sm={10}>
                                <Input type="email" name="contactPersonEmail" 
                                    defaultValue={props.data?.contactPersonEmail} 
                                    innerRef={register({ required: true })} />
                            </Col>
                        </FormGroup>
                    </ListGroupItem>
                </ListGroupItem>
            </ListGroup>
            <br />

            <Input type="hidden" name="orgProfileImgURL" value={_logoImge} innerRef={register()} />
            <Input type="hidden" name="Overwrite" value={overwriteFlag} innerRef={register()} />
            <Input type="hidden" name="_etag" defaultValue={props.data?._etag}  innerRef={register()} />

            <FormGroup row={true}>
                <Col sm={12}>
                    {
                        !isNew && (
                            <Button color="danger" size="lg" className="float-left" disabled={props.ui.loading || props.ui.processing} 
                                onClick={toggleRemoveWarning}>
                                <i className="fas fa-trash-alt mr-1"></i>&nbsp;Remove
                            </Button>
                        )
                    }
                    <Button type="submit" color="primary" size="lg" className="float-right" disabled={!dirty || props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("false")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Save
                    </Button>
                    {
                        props.ui.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                    }   
                </Col>
            </FormGroup>
            <Modal isOpen={overwriteWarningFlag} toggle={overwriteHandleWarning}>
                <ModalHeader toggle={overwriteHandleWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Record you changing is not the latest version. <br/>
                        Please confirm if you want to :- <br/>
                        1. Overwrite. Update latest data with your changes. <br/>
                        2. Reload. Discarding your current changes.<br/>
                        3. Cancel. Remain your changes.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>                 
                    <Button form="DetailsFrom" type="submit" color="warning" size="lg" className="float-right" 
                        disabled={props.ui.loading || props.ui.processing} 
                        onClick={() => setOverwriteFlag("true")}>
                        <i className="fas fa-save mr-1"></i>&nbsp;Overwrite
                    </Button>
                    <Button color="danger" size="lg" onClick={handleReloadData}>
                        <i className="fas fa-redo-alt mr-1"></i>&nbsp; Reload
                    </Button>
                    <Button color="secondary" size="lg" onClick={overwriteHandleWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            
            <Modal isOpen={removeWarning} toggle={toggleRemoveWarning} >
                <ModalHeader toggle={toggleRemoveWarning}>Warning</ModalHeader>
                <ModalBody>
                    <p>Please confirm to remove this record<br/>
                        Note. This action is irreversible.<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <Button color="danger" size="lg" onClick={handleRequestDelete}>
                        <i className="fas fa-trash-alt mr-1"></i>&nbsp; Proceed to Remove
                    </Button>
                    <Button color="secondary" size="lg" onClick={toggleRemoveWarning}>
                        <i className="fas fa-times-circle mr-1"></i>&nbsp;Cancel
                    </Button>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={props.ui.processState === 3} backdrop="static" keyboard={false} >
                <ModalHeader>Success</ModalHeader>
                <ModalBody>
                    <p>Succesfully remove!<br/>
                    </p>
                </ModalBody>
                <ModalFooter>    
                    <RouterNavLink to="/organisers" className="nav-link" exact>
                        <i className="fas fa-list mr-1"></i>Back to Organiser List
                    </RouterNavLink>
                </ModalFooter>
            </Modal> 
            <Modal isOpen={UploadFlag} toggle={toggleUploadFlag}>
                <ModalHeader toggle={toggleUploadFlag}>Upload Progress</ModalHeader>
                <ModalBody>
                    <Progress value={_uploadProgress}>{_uploadProgress}%</Progress>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={(_uploadProgress !== 100) ? true : false} onClick={toggleUploadFlag}>Close</Button>
                </ModalFooter>
            </Modal> 
        </Form>
        <br/><br/>
        <br/>
        {/* <Row>
            <Col lg="12">
                {JSON.stringify(props.data)}
            </Col>
        </Row> */}
        <Prompt when={dirty && !isSubmitted} 
            message="Are you sure want to discard your changes?"
        />
    </Fragment>
    
  );
}